import { render, staticRenderFns } from "./WarehousingDetail.vue?vue&type=template&id=2b62fc91&scoped=true"
import script from "./WarehousingDetail.vue?vue&type=script&lang=js"
export * from "./WarehousingDetail.vue?vue&type=script&lang=js"
import style0 from "./WarehousingDetail.vue?vue&type=style&index=0&id=2b62fc91&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b62fc91",
  null
  
)

export default component.exports